import { CreateEditCartUi } from '@/components/Cart/modal/CreateEdit/CreateEditUiModel';
import cacheKeys from '@/data/api/cacheKeys';
import { createCart, publishCart } from '@/data/api/request/cartRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createCartRequestFromUiModel } from '../mapper';

export const useCreateAndPublish = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (args: CreateEditCartUi) => {
      const request = createCartRequestFromUiModel(args);
      const createCartResponse = await createCart(request);
      await publishCart(createCartResponse.cart_id);
      queryClient.invalidateQueries({ queryKey: [cacheKeys.carts.list] });
    },
  });
};
